import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Components/FontLoader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Components/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Components/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Components/SocialSidebar.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
